import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import PageNavigation from './navigation/PageNavigation';

function App() {
	return (
		<Router>
			<PageNavigation />
		</Router>
	);
}

export default App;
